module.exports = __webpack_public_path__ + "static/microsoft-786c0ced6cd4a10455ec9a51b012e2c0.svg";